import { createSlice } from '@reduxjs/toolkit';
import api from '../Components/_helpers/api';

export const empresaSlice = createSlice({
  name: 'empresa',
  initialState: {
    data: { data: [] },
    currentFilters: {},
    isLoading: true,
    error: '',
  },
  reducers: {
    requestEmpresa: (state, action) => {
      state.isLoading = true;
      state.currentFilters = action.payload;
      state.error = '';
    },
    requestEmpresaSuccess: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    requestEmpresaFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    setError: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const { requestEmpresa, requestEmpresaSuccess, requestEmpresaFailure, setError } = empresaSlice.actions;

//Thunks
export const RequestEmpresasAsync = (payload) => (dispatch) => {
  let filters = payload || {};
  dispatch(requestEmpresa(filters));

  api
    .post('/Emisor/GetAllEmpresas', payload)
    .then((data) => {
      dispatch(requestEmpresaSuccess(data.data));
    })
    .catch((e) => {
      console.log(e);
      dispatch(requestEmpresaFailure(e));
    });
};

export const RequestMisEmpresasAsync = (payload) => (dispatch) => {
  let filters = payload || {};
  dispatch(requestEmpresa(filters));

  api
    .post('/MisEmisores/GetMisEmpresas', payload)
    .then((data) => {
      dispatch(requestEmpresaSuccess(data.data));
    })
    .catch((e) => {
      console.log(e);
      dispatch(requestEmpresaFailure(e));
    });
};

export const SaveEmpresaAsync = (payload) => (dispatch) =>
  new Promise(function (resolve, reject) {
    api
      .post('/Emisor', { ...payload })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const UpdateEmpresaAsync = (payload) => (dispatch) =>
  new Promise(function (resolve, reject) {
    api
      .put('/Emisor', { ...payload })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const ActivarEmpresaAsync = (payload) => (dispatch) =>
  new Promise(function (resolve, reject) {
    api
      .put('/Emisor/Activar', { ...payload })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const DesactivarEmpresaAsync = (payload) => (dispatch) =>
  new Promise(function (resolve, reject) {
    api
      .put('/Emisor/Desactivar', { ...payload })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const DeleteEmpresaAsync = (payload) => (dispatch) =>
  new Promise(function (resolve, reject) {
    api
      .delete(`/Emisor?empresaId=${payload}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });

//Selector
export const selectData = (state) => state.empresa.data;
export const selectIsLoading = (state) => state.empresa.isLoading;
export const selectError = (state) => state.empresa.error;
export const selectCurrentFilters = (state) => state.empresa.currentFilters;

export default empresaSlice.reducer;
